/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AlarmResolutionType } from "./AlarmResolutionType";
import {
  AlarmResolutionTypeFromJSON,
  AlarmResolutionTypeFromJSONTyped,
  AlarmResolutionTypeToJSON,
  AlarmResolutionTypeToJSONTyped,
} from "./AlarmResolutionType";

/**
 *
 * @export
 * @interface ResolveAlarmRequest
 */
export interface ResolveAlarmRequest {
  /**
   *
   * @type {string}
   * @memberof ResolveAlarmRequest
   */
  alarmId: string;
  /**
   *
   * @type {string}
   * @memberof ResolveAlarmRequest
   */
  userEmail: string;
  /**
   *
   * @type {AlarmResolutionType}
   * @memberof ResolveAlarmRequest
   */
  resolutionType: AlarmResolutionType;
  /**
   *
   * @type {string}
   * @memberof ResolveAlarmRequest
   */
  note?: string | null;
}

/**
 * Check if a given object implements the ResolveAlarmRequest interface.
 */
export function instanceOfResolveAlarmRequest(
  value: object,
): value is ResolveAlarmRequest {
  if (!("alarmId" in value) || value["alarmId"] === undefined) return false;
  if (!("userEmail" in value) || value["userEmail"] === undefined) return false;
  if (!("resolutionType" in value) || value["resolutionType"] === undefined)
    return false;
  return true;
}

export function ResolveAlarmRequestFromJSON(json: any): ResolveAlarmRequest {
  return ResolveAlarmRequestFromJSONTyped(json, false);
}

export function ResolveAlarmRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResolveAlarmRequest {
  if (json == null) {
    return json;
  }
  return {
    alarmId: json["alarmId"],
    userEmail: json["userEmail"],
    resolutionType: AlarmResolutionTypeFromJSON(json["resolutionType"]),
    note: json["note"] == null ? undefined : json["note"],
  };
}

export function ResolveAlarmRequestToJSON(json: any): ResolveAlarmRequest {
  return ResolveAlarmRequestToJSONTyped(json, false);
}

export function ResolveAlarmRequestToJSONTyped(
  value?: ResolveAlarmRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    alarmId: value["alarmId"],
    userEmail: value["userEmail"],
    resolutionType: AlarmResolutionTypeToJSON(value["resolutionType"]),
    note: value["note"],
  };
}
